import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  createHouseholdMember,
  updateHouseholdMember
} from '../../../sagas/routines';
import { resetHouseholdMemberForm } from '../../../actions/components/household-member-form';

const initialState = {
  saving: false,
  saved: false,
  savingError: null
};

const createHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    saving: true,
    saved: false,
    savingError: null
  }),
  [routine.FAILURE]: (state, { error }) => set('savingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true,
    savingError: null
  })
});

const updateHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    saving: true,
    saved: false,
    savingError: null
  }),
  [routine.FAILURE]: (state, { error }) => set('savingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true,
    savingError: null
  })
});

const resetHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...createHandler(createHouseholdMember),
  ...updateHandler(updateHouseholdMember),
  ...resetHandler(resetHouseholdMemberForm)
});
